import {ReducerStatuses} from "services/utils/utils";
import {createSlice} from "@reduxjs/toolkit";
import {skillConfirmSuccess} from "store/reducer/skills/confirm/reducer";
import {favoritePeopleSuccess} from "store/reducer/people/favorite/reducer";

export const initialState = {
    status: ReducerStatuses.IDLE,
    error: "",
    data: null,
    slug: "",
    recommendation: {
        recommendation_enabled: false
    }
};
const slice = createSlice({
    name: "privateProfile",
    initialState,
    reducers: {
        getPrivateProfileStart: (state, {payload}) => {
            state.data = null;
            state.status = ReducerStatuses.LOADING;
            state.slug = payload.slug;
        },
        getPrivateProfileFailure: (state, {payload}) => {
            state.status = ReducerStatuses.ERROR;
            state.error = payload;
        },
        getPrivateProfileSuccess: (state, {payload}) => {
            state.data = payload;
            state.status = ReducerStatuses.SUCCESS;
        },
        getPrivateProfileRecommendationStart: (state) => {
            state.recommendation = {
                recommendation_enabled: false
            };
        },
        getPrivateProfileRecommendationSuccess: (state, {payload}) => {
            state.recommendation = payload;
        }
    },
    extraReducers: {
        [skillConfirmSuccess.type]: (state, {payload}) => {
            if(state.data) {
                if(payload.type === "user") {
                    let skill = state.data.profile.skills_raw.find(i => i.skill_name === payload.skill_name);
                    skill.confirmers_id = [...skill.confirmers_id, 1];
                    skill.confirmed_by_you = true;
                }
                if(payload.type === "company") {
                    let company = state.data.companies.find(i => i.id === payload.id);
                    if(company) {
                        let skill = company.skills_raw.find(i => i.skill_name === payload.skill_name);
                        skill.confirmers_id = [...skill.confirmers_id, 1];
                        skill.confirmed_by_you = true;
                    }
                }
            }
        },
        [favoritePeopleSuccess.type]: (state, {payload}) => {
            if(state.data) {
                if (payload.type === "user") {
                    state.data.profile.favorite = payload.favorite;
                }
            }
        }
    }
});
const {reducer, actions} = slice;
export const {
    getPrivateProfileFailure, getPrivateProfileStart, getPrivateProfileSuccess, getPrivateProfileRecommendationStart, getPrivateProfileRecommendationSuccess
} = actions;
export default reducer;